import { practice } from '../data/practice.js';

const cols = [
  { title: 'Praktijk', items: ['Over mij', 'Behandeling', 'Tarieven', 'Vergoeding'] },
  { title: 'Contact', items: [practice.email, 'WhatsApp', practice.city] },
  {
    title: 'Administratief',
    items: [`KVK ${practice.kvk}`, 'Privacy', 'Algemene voorwaarden'],
  },
];

export default function Footer() {
  return (
    <footer
      data-screen-label="07 Footer"
      style={{
        background: 'var(--cream)',
        borderTop: '1px solid var(--line)',
        padding: '48px 0 36px',
      }}
    >
      <div
        className="footer-grid"
        style={{
          maxWidth: 'var(--maxw-content)',
          margin: '0 auto',
          padding: '0 var(--gutter)',
          display: 'grid',
          gridTemplateColumns: '2fr 1fr 1fr 1fr',
          gap: 48,
          alignItems: 'flex-start',
        }}
      >
        <div className="footer-brand">
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
            <img src="/assets/logo-brain.png" alt="" style={{ height: 44, width: 'auto' }} />
            <span
              style={{
                fontFamily: 'var(--font-display)',
                fontSize: 24,
                fontWeight: 400,
                color: 'var(--ink)',
                letterSpacing: '0.5px',
                lineHeight: 1,
              }}
            >
              Psycholoog <span style={{ fontStyle: 'italic' }}>Maxime</span>
            </span>
          </div>
          <p
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 13,
              lineHeight: 1.7,
              color: 'var(--ink-3)',
              marginTop: 14,
              maxWidth: '38ch',
            }}
          >
            Online praktijk voor psychotherapie & diagnostiek. Tevens werkzaam bij Oh My Mood.
          </p>
        </div>

        {cols.map((c) => (
          <FooterCol key={c.title} title={c.title} items={c.items} />
        ))}
      </div>

      <div
        className="footer-bottom"
        style={{
          maxWidth: 'var(--maxw-content)',
          margin: '32px auto 0',
          padding: '24px var(--gutter) 0',
          borderTop: '1px solid var(--line)',
          display: 'flex',
          justifyContent: 'space-between',
          fontFamily: 'var(--font-body)',
          fontSize: 12,
          color: 'var(--ink-3)',
        }}
      >
        <span>© {new Date().getFullYear()} {practice.name}</span>
        <span>BIG-geregistreerd · {practice.title}</span>
      </div>
    </footer>
  );
}

function FooterCol({ title, items }) {
  return (
    <div>
      <div
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 11,
          fontWeight: 500,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: 'var(--ink-3)',
          marginBottom: 14,
        }}
      >
        {title}
      </div>
      <ul
        style={{
          listStyle: 'none',
          padding: 0,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
        }}
      >
        {items.map((i) => (
          <li key={i}>
            <a
              href="#"
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: 14,
                color: 'var(--ink)',
                textDecoration: 'none',
              }}
            >
              {i}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
